import axios from "../../../utils/axios";
import { orderSliceActions } from "./order-Slice";

export const setCartInformation = (cartDetails) => {
  return (dispatch) => {
    dispatch(orderSliceActions.setCartDetails(cartDetails));
  };
};

export const setDeliveryTypeInformation = (deliveryType) => {
  return (dispatch) => {
    dispatch(orderSliceActions.setDeliveryTypeDetails(deliveryType));
  };
};

export const setDeliveryAddressInformation = (address) => {
  return (dispatch) => {
    dispatch(orderSliceActions.setDeliveryAddressDetails(address));
  };
};

export const setOrderInformation = (orderInfo) => {
  return (dispatch) => {
    dispatch(orderSliceActions.setOrderDetails(orderInfo));
  };
};

export const fetchCart = async () => {
  return await axios.get("/carts/");
};

export const updateCart = async (cartInformation) => {
  return await axios.put("/carts/", cartInformation);
};

export const saveOrder = async (orderDetails) => {
  return await axios.post("/orders/info/", orderDetails);
};

export const reserveOrder = async (orderDetails) => {
  return await axios.post("/orders/reserve/", orderDetails);
};

export const fetchCartDeliveryTypes = async (cartId) => {
  return await axios.get(`/carts/${cartId}/delivery-types/`);
};

export const getSupplierDetails = async (id) => {
  return await axios.get(`/suppliers/${id}/`);
};

export const placeOrder = async (orderParams) => {
  return await axios.post("/orders/", { ...orderParams });
};

export const fetchOrders = async (orderParams) => {
  return await axios.get("/orders/", {}, { ...orderParams });
};

export const fetchOrderDetail = async (orderId) => {
  return await axios.get(`/orders/${orderId}/`);
};

export const addReviewInOrder = async (orderId, params) => {
  return await axios.post(`/consumer-ratings/${orderId}`, { ...params });
};

export const cancelOrder = async (orderId, formData) => {
  return await axios.patch(`/orders/${orderId}/cancel/`, formData);
};

export const fetchSupportedCurrencies = async () => {
  return await axios.get(`/transactions/currency-gateways`);
};
